import { request } from '@remote/api/request'
import { IErrorRes } from '@remote/type'
type IRes<T> = {
  'code': number
  'ret': number
  'data': T
  'msg': 'ok'
}

type TSvip = {
  // 0 | 1
  'isvip': number
  'vas_type': number
  'isyear': number
  'expire': number
  'expire_time': string
  // 0 | 1
  'autodeduct': number
  'activate_url': string
  'register': number
}

type TGetHeziAccountInfoRes = {
  'userid': string
  'username': string
  'nickname': string
  'avatar': string
  'msg_config': {
    'circle_notice': 0
    'transfer_notice': 0
    'like_notice': 0
  }
  'registration_id': string
  'platform': 'string'
  'is_scrape': 1
  'is_all_scrape': 0
  'is_auto_download': 1
  'is_speed_limit': 0
  'is_auto_run_smb': 1
  'is_smb_allow_anonymous': 1
  'is_auto_run_thumb': 0
  'is_auto_run_backer': 0
  'is_service_auto': 0
  'is_app_exp': 0
  'is_test': true
  'is_audit': false
  'vip': {
    'isvip': 1
    'vas_type': 2
    'isyear': 0
    'expire': 20250803
    'expire_time': '2025-08-03T15:42:14+08:00'
    'autodeduct': 0
    'pay_url': 'http://test-h5-hezi.xunlei.com/box/?status_bar=false&toolbar=false#/member/upgrade'
    'svip_pay_url': 'https://pay-hezi.xunlei.com/2020/android-sl-pay/?frompage=hygw&referfrom=v_pc_hygw_ggong_dhl_info&platform=default&aidfrom=hygw_dhl_kt&status_bar=false&toolbar=false'
    'activate_url': 'https://test-h5-hezi.xunlei.com/box??status_bar=false&toolbar=false#/member/activate'
    'register': 20221216
  }
  'svip': TSvip
}

export const getHeziAccountInfo = (): Promise<IRes<TGetHeziAccountInfoRes>> => {
  const url = '/api/v1/user/info'
  const params = { platform: 'pc' }
  return request(url, params, { apiEnv: 'heziProduction', method: 'POST' })
    .then(result => {
      return Array.isArray(result) ? result[1] : {}
    })
}

export const loginAuth = (params: { userid: string; platform_name: string}) => {
  const url = '/api/v1/login/auth'
  return request(url, params, { apiEnv: 'heziProduction', method: 'POST' })
}

type IGetShubResourceRes = IRes<{
  'Provider': number
  'SignedURL': string
  'AccToken': string
  'Duration': {
    'UrlDuration': number
    'TokenDuration': number
  }
}>

export const getShubResource = (gcid:string):Promise<[IErrorRes, IGetShubResourceRes]> => {
  const url = '/api/v1/shub/resource'
  return request(url, {gcid}, { apiEnv: 'heziProduction', method: 'POST' })
}